import Financial from "../icons/financial.svg"
import Store from "../icons/store.svg"
import Branches from "../icons/branches.svg"
import Car from "../icons/car.svg"
import Dollar from "../icons/dollar.svg"
import Cloud from "../icons/cloud.svg"
import Flag from "../icons/flag.svg"
import Global from "../icons/global.svg"
import Link from "../icons/link.svg"
import User from "../icons/user.svg"
import Frame from "../icons/frame.svg"
import Market from "../icons/market.svg"
import Refresh from "../icons/refresh.svg"
import Home from "../icons/home.svg"
import Enter from "../icons/enter.svg"
import UserList from "../icons/list.svg"
import Caution from "../icons/caution.svg"
import Message from "../icons/message.svg"
import Location from "../icons/location.svg"
import Heart from "../icons/heart.svg"
import File from "../icons/file.svg"
import Deployment from "../icons/deployment.svg"
import Checked from "../icons/checked.svg"
import Calendar from "../icons/calendar.svg"

export const icons = [
  { key: "user", src: User},
  { key: "financial", src: Financial},
  { key: "global", src: Global},
  { key: "location", src: Location},
  { key: "car", src: Car},
  { key: "market", src: Market},
  { key: "Home", src: Home},
  { key: "dollar", src: Dollar},
  { key: "file", src: File},
  { key: "link", src: Link},
  { key: "cloud", src: Cloud},
  { key: "message", src: Message},
  { key: "heart", src: Heart},
  { key: "refresh", src: Refresh},
  { key: "app-store", src: Store},
  { key: "flag", src: Flag},
  { key: "deployment", src: Deployment},
  { key: "branches", src: Branches},
  { key: "checked", src: Checked},
  { key: "calendar", src: Calendar},
  { key: "userList", src: UserList},
  { key: "frame", src: Frame},
  { key: "enter", src: Enter},
  { key: "caution", src: Caution},
];
